import { render, staticRenderFns } from "./DposDetail.vue?vue&type=template&id=2ae58809&"
import script from "./DposDetail.vue?vue&type=script&lang=js&"
export * from "./DposDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports